<template>
    <!--操作日志 -->
    <div :class="phoneClass || 'log-list-container'">
        <content-header></content-header>
        <div class="store-table">
            <div class="search-bar">
                <div class="search-left">
                    <div class="status-index">
                        <span class="top-title">{{$t('log.type')}}</span>
                        <el-select v-model="searchForm.type" clearable style="width:190px;" @change="initPage(),getLogList()">
                            <el-option
                                    v-for="item in logType"
                                    :key="item.label"
                                    :label="item.label"
                                    :value="item.value">
                            </el-option>
                        </el-select>

                    </div>
                    <div class="status-index">
                        <el-date-picker
                            v-model="timeArr"
                            style="vertical-align:middle;margin-left:20px;height:30px;line-height:22px;"
                            class="my-date-picker"
                            type="daterange"
                            :range-separator="$t('log.to')"
                            :start-placeholder="$t('log.startData')"
                            value-format='timestamp'
                            @change="initPage(),changeTimeValue()"
                            :end-placeholder="$t('log.endData')"
                        >
                        </el-date-picker>
                    </div>
                    <!--<div class="status-index">-->
                        <!--<el-button @click="goWarnningList" type="success">{{$t('log.warningLog')}}</el-button>-->
                    <!--</div>-->
                </div>
                <!--日志列表无需按照设备查找-->
<!--                <div class="search-right">
                    <el-input
                        @change="getLogList()"
                        clearable
                        placeholder="查找设备"
                        style="width:260px"
                        v-model="searchForm.key">
                        <i slot="prefix" class="el-input__icon el-icon-search"></i>
                    </el-input>
                </div>-->
            </div>
            <div class="phone-log-table-list" v-if="phoneClass">
                <div class="phone-log-table-item" v-for="(item, index) in actionList" :key="index">
                    <div class="log-tab-title">
                        {{item.target_type | parseLogType()}}
                    </div>
                    <div class="log-tab-inner">
                        <img src="../../assets/img/phoneIcon/icon1.png">
                        操作人：
                        {{ item.operator.email }}
                    </div>
                    <div class="log-tab-inner">
                        <img src="../../assets/img/phoneIcon/icon2.png">
                        操作内容：
                        <span v-if="lang">{{JSON.parse(item.content).operate}}{{JSON.parse(item.content).name}}{{JSON.parse(item.content).desc}}</span>
                        <span v-else>{{JSON.parse(item.content).operate_en}} {{JSON.parse(item.content).name_en}} {{JSON.parse(item.content).desc}}</span>
                    </div>
                    <div class="log-tab-inner">
                        <img src="../../assets/img/phoneIcon/icon3.png">
                        操作时间：
                        {{ item.create_time | timeFormat(1)}}
                    </div>
                </div>
            </div>
            <div class="table-outer" v-else>
                <el-table :data="actionList" :header-cell-style="{background:'#fafbfc'}" class="normal-table" style="width: 100%">
                    <el-table-column prop="operator.email" min-width="180px" :label="$t('log.operator')" ></el-table-column>
                    <el-table-column prop="target_type" min-width="100px" :label="$t('log.operatingModule')">
                        <div slot-scope="scope">
                            {{scope.row.target_type | parseLogType()}}
                        </div>
                    </el-table-column>
                    <el-table-column prop="content" min-width="180px"  :label="$t('log.operate_content')">
                        <div slot-scope="scope">
                            <span v-if="lang">{{JSON.parse(scope.row.content).operate}}{{JSON.parse(scope.row.content).name}}{{JSON.parse(scope.row.content).desc}}</span>
                            <span v-else>{{JSON.parse(scope.row.content).operate_en}} {{JSON.parse(scope.row.content).name_en}} {{JSON.parse(scope.row.content).desc}}</span>
                        </div>
                    </el-table-column>
                    <el-table-column prop="create_time" min-width="180px" :label="$t('log.operate_time')">
                        <div slot-scope="scope">
                            {{scope.row.create_time | timeFormat(1)}}
                        </div>
                    </el-table-column>
                    <!--<el-table-column prop="is_active" label="是否激活">-->
                        <!--<template slot-scope="scope" >-->
                            <!--{{scope.row.is_active ? '是' : '否'}}-->
                            <!--&lt;!&ndash; 0:未激活 1:激活 &ndash;&gt;-->
                        <!--</template>-->
                    <!--</el-table-column>-->
                    <!--<el-table-column prop="device.device_address" label="所属服务商"></el-table-column>-->
                    <el-table-column label="操作" align="center" fixed="right" width="100"  v-if="false">
                        <div slot-scope="scope" class='my-table-button'>
                            <img src="../../assets/img/btn/edit.png" @click="editDevice(scope.row)">
                            <img src="../../assets/img/btn/delete.png" @click="deleteDevice(scope.row)">
                        </div>
                    </el-table-column>
                </el-table>
            </div>
            <div class="pagination" style="text-align:right;padding:20px;">
                <el-pagination
                    @current-change="pageChange"
                    :current-page="currentPage"
                    :page-size="pageSize"
                    layout="total, prev, pager, next"
                    :total="total"
                    background>
                </el-pagination>
            </div>
        </div>
    </div>
</template>


<script>
import Core from "core/core";
import contentHeader from '../../components/content-header'
import {refresh} from "core/winSize"
import i18n from "../../locales";
export default {
    data() {
        return {
	        phoneClass: '',
            actionList: [],
            currentPage: 1,
            pageSize: 10,
            total: 0,
            searchForm: {
                userId: '',
                type: '',
                beginTime: '',
                endTime: ''
            },
            logType: [],
            dealerList: [],
            timeArr: [],
            lang: ''
        };
    },
    components: {
        contentHeader
    },
    created() {
	    refresh(this,'phoneClass-log-list-container');
	    window.onresize = function(){
		    setTimeout(function(){
			    refresh(this,'phoneClass-log-list-container');
		    },10)
	    };
    },
    mounted() {
        this.initLogType()
        this.getLogList();
        this.getDealerList();
    },
    computed: {
    },
    methods: {
	    initLogType () {
	        let user = Core.Data.getUser()
	        let lang = localStorage.getItem('skf.data.lang')
	        this.lang = lang =='"zh"' ? true : false
	        if (user.role === 1 || user.role === 2 || user.role === 10) {
		        if (lang == '"en"') {
			        this.logType = [
				        {label: 'Device Management', value: 1},
				        {label: 'Provider Management', value: 2},
				        {label: 'Warning Log', value: 3}
			        ]
		        } else {
			        this.logType = [
				        {label: '设备管理', value: 1},
				        {label: '服务商管理', value: 2},
				        {label: '告警日志', value: 3}
			        ]
		        }
	        } else {
		        if (lang == '"en"') {
			        this.logType = [
				        {label: 'Device Management', value: 1},
				        {label: 'Warning Log', value: 3}
			        ]
		        } else {
			        this.logType = [
				        {label: '设备管理', value: 1},
				        {label: '告警日志', value: 3}
			        ]
		        }
	        }
	    },
	    goWarnningList() {
	        this.$router.push({
	            path: '/log/warning'
	        })
	    },
        getDealerList() {
            Core.Api.Agent.list().then(res => {
                let agentList = res.agent_list;
                this.dealerList = agentList;
            })
        },
        changeTimeValue() {
            if(this.timeArr && this.timeArr.length) {
                let [time1,time2] = [...this.timeArr];
                this.searchForm.before = time1/1000;
                this.searchForm.after  = time2/1000;
            }else {
                this.searchForm.before = '';
                this.searchForm.after  = '';
            }
            console.log(this.searchForm.before)
            console.log(this.searchForm.after)
            this.getLogList();
        },
        getLogList() {
            if (this.searchForm.type === 3) {
                this.goWarnningList()
                return
            }
            Core.Api.Action.list(this.searchForm.key,this.searchForm.type,this.searchForm.before,this.searchForm.after,this.currentPage)
                .then(res => {
                    let actionList = res.action_list;
                    this.actionList = actionList;
                    this.total = res.count;
                    console.log(actionList);
                })

        },
        initPage(){
            this.currentPage = 1
            console.log("现在是第"+this.currentPage+"页");
        },
        pageChange(val) {
            this.currentPage = val;
            this.getLogList();
        },
        deleteDevice(row) {
            if(!row.id) {
                return
            }
        },
        editDevice(row) {
            if(!row.id) {
                return
            }
            this.$router.push(`/device/detial?device_id=${row.id}`)
        }
    },


};
</script>

<style scoped lang="scss">
@import '../../assets/style/mixin.scss';
.log-list-container {
    background-color: #E5EBEF;
    height: 100%;
    .store-table {
        margin: 30px 40px;
        background-color: #FFFFFF;
        .search-bar {
            @include flex-sb;
            padding: 20px;
            .status-index {
                margin-right: 12px;
                &:last-child {
                    margin-right: 0;
                }
            }
        }
        .table-outer {
            padding: 0 20px;
        }
    }
}
</style>

<style lang="scss">
    .log-list-container {
        .table-outer {
            .cell {
                white-space:nowrap;
                overflow:hidden; //超出的文本隐藏
                text-overflow:ellipsis; //溢出用省略号显示
            }
            .cell:hover {
                /*background: #e2e2e2;*/
                white-space: normal;
                overflow: visible; //超出的文本隐藏
                position: relative;
                z-index: 10000;
                text-overflow:clip;
                /*background: #f6f7fb;*/
            }

        }
    }
    //配置移动端时间选择
    .phoneClass-log-list-container {
        background: #E5EBEF;
        min-height: calc(100vh - 110px);
        padding-bottom: 50px;
        .store-table {
            .phone-search-bar {
                display: flex;
                justify-content: space-between;
                padding: 4px 15px;
                background: white;
                .phone-bar-right {
                    display: flex;
                    align-items: center;
                    img {
                        width: 10px;
                        height: 12px;
                        margin-left: 5px;
                    }
                }
            }
            .search-bar {
                padding: 0 12px 15px;
                background: white;
                .search-left {
                    display: flex;
                    flex-direction: column;
                }
                .status-index {
                    margin-top: 15px;
                    width: 100%;
                    .top-title {
                        min-width: 100px;
                    }
                    .el-select {
                        flex: 1;
                    }
                    .el-date-editor {
                        margin-left: 0 !important;
                        min-width: 300px;
                        width: 100%;
                        //max-width: 90vw;
                    }
                }
            }
            .table-outer {
                margin-top: 15px;
            }
            .phone-log-table-list {
                padding: 12px;
                .phone-log-table-item {
                    background: white;
                    margin-bottom: 12px;
                    padding: 12px 17px;
                    border-radius: 4px;
                    .log-tab-title {
                        font-size: 16px;
                        font-weight: 500;
                        color: #2D2E32;
                        border-bottom: 1px solid #EDF0F3;
                        padding-bottom: 12px;
                        margin-bottom: 10px;
                    }
                    .log-tab-inner {
                        display: flex;
                        align-items: center;
                        margin-bottom: 4px;
                        font-size: 14px;
                        color: #767A88;
                        &:last-child {
                            margin-bottom: 0;
                        }
                        img {
                            min-width: 12px;
                            max-width: 12px;
                            min-height: 12px;
                            max-height: 12px;
                            margin-right: 9px;
                        }
                    }
                }

            }
            /*页码适配移动端*/
            .pagination {
                padding: 0 0 20px 0 !important;
                text-align: center !important;
                .el-pagination {
                    padding: 0;
                    button {
                        width: 20px;
                        min-width: 0;
                        height: 30px;
                    }
                    .el-pager {
                        .number {
                            margin: 0 3px !important;
                            padding: 0 !important;
                            min-width: 0px;
                            width: 20px !important;
                            height: 30px !important;
                        }
                        .el-icon-more {

                            margin: 0 3px !important;
                            padding: 0 !important;
                            min-width: 0px;
                            width: 20px !important;
                            height: 30px !important;
                        }
                    }
                }
            }
        }

    }
    /*.el-popper,*/
    .el-date-range-picker {
        left: 0 !important;
        .el-picker-panel__body-wrapper {
            .el-picker-panel__body{
                min-width: 300px;
                max-width: 100vw;

                >div>div>div {
                    font-size: 16px;
                    margin: 0;
                }
            }
        }
    }
</style>
